export default {"src":"/_next/static/media/download.340d34c5.svg","height":800,"width":800};